<template>
    <div
        v-spinner="pageLoading"
        class="customer-person-info"
    >
        <v-spinner :opacity="0.5">
            {{ $t('加载中...') }}
        </v-spinner>
        <template v-if="userinfo">
            <div class="info-head">
                <div
                    @click="handleChangeAvatar"
                    class="personal-avatar"
                >
                    <img
                        :src="userinfo.avatar_url || defaultAvatar"
                        class="personal-head avatar"
                    >
                    <span class="personal-avatar-mask">{{ $t('编辑') }}</span>
                </div>
                <div class="username">
                    {{ userinfo.name }}
                </div>
            </div>
            <div class="info-body">
                <v-page-header level="section" :title="$t('个人资料')" />
                <v-descriptions>
                    <v-description-item :text="$t('真实姓名')" :value="userinfo.name ? userinfo.name : '-'" />
                    <v-description-item
                        v-if="userinfo.qq && !isInWhiteList && !isPrivate"
                        :text="$t('员工QQ号')"
                        :value="userinfo.qq ? userinfo.qq : '-' "
                    />
                    <v-description-item
                        v-if="userinfo.org_info"
                        :text="$t('部门')"
                    >
                        <ul v-if="userinfo.org_info.length > 0">
                            <li
                                v-for="(item, index) in userinfo.org_info"
                                :key="index"
                            >
                                {{ item.org_name }}
                            </li>
                        </ul>
                        <span v-else>-</span>
                    </v-description-item>
                    <v-description-item :text="$t('性别')">
                        <span>{{ userinfo.gender === 1 ? $t('男') : $t('女') }}</span>
                    </v-description-item>
                    <!-- <description-item
                        v-if="userinfo.mobile || smsAbility"
                        text="手机"
                    >

                            1. 如果没有手机号，则显示绑定按钮，绑定的时候，会对即将绑定的手机号进行校验（一个手机号有只能绑定一个账号
                            关联两个帐号的限制），如果改帐号未绑定其他帐号，绑定之后，则直接升级为绑定状态，如果改帐号已绑定过其他
                            帐号，则提示用户，用户只能进行关联操作，关联成功后，状态变为【已关联】状态，显示【升级为绑定的按钮】。
                            2. 如果有手机号，状态是未关联状态，则显示【绑定】按钮，如果手机号满足绑定的要求，则状态直接升级为已绑定状态，
                            如果不满足绑定的要求，只满足关联的要求，则状态变为已关联，如果不满足关联的要求。
                            3. 如果有手机号，状态是已关联状态，则显示【升级为绑定的按钮】按钮。
                            4. 如果手机号不满足绑定和关联的要求，用户可以选择更换手机号，进行更换其他手机号进行操作。
                            5. 只要有手机号，则显示【更换手机号】按钮。

                        <div>
                            <text-button
                                v-if="!userinfo.mobile"
                                @click="handleBindPhone"
                                inline
                            >
                                立即绑定
                            </text-button>
                            <template v-if="userinfo.mobile">
                                <span>{{ userinfo.mobile }}</span>
                                <template v-if="userinfo.is_mobile_bind && smsAbility">
                                    <span class="tag">已绑定</span>
                                    <text-button
                                        @click="handleChangeBindPhone"
                                        style="margin-left: 10px;"
                                        inline
                                    >
                                        更换
                                    </text-button>
                                </template>
                                <template v-else-if="smsAbility">
                                    <span class="tag">{{ userinfo.is_mobile_link ? '已关联' : '未关联' }}</span>
                                    <text-button
                                        @click="handleBindPhone"
                                        inline
                                    >
                                        {{
                                            !userinfo.is_mobile_link ? '立即绑定' : '升级为绑定'
                                        }}
                                    </text-button>
                                </template>
                            </template>
                            <p
                                v-if="!userinfo.is_mobile_bind && smsAbility"
                                class="description"
                            >
                                绑定后该手机号可用于找回密码、拨打企点电话等功能
                            </p>
                        </div>
                    </description-item> -->
                    <v-description-item :text="$t('电话')">
                        <span>{{ userinfo.tel | formatEmpty }}</span>
                    </v-description-item>
                    <v-description-item :text="$t('邮箱')">
                        <span>{{ userinfo.email | formatEmpty }}</span>
                    </v-description-item>
                </v-descriptions>
                <v-descriptions
                    v-if="userinfo.has_call === 1"
                >
                    <v-description-item :text="$t('分机')">
                        <span>{{ userinfo.cc_info.voice_broadcast_number | formatEmpty }}</span>
                    </v-description-item>
                    <v-description-item :text="$t('VOIP号码')">
                        <div v-if="userinfo.cc_info">
                            <v-tip
                                ref="dynamicData"
                                placement="top"
                            >
                                <template slot-scope="props">
                                    <span>{{ props.data }}</span>
                                </template>
                            </v-tip>
                            <div
                                v-for="(item, index) in userinfo.cc_info.voips"
                                :key="index"
                                class="flex-row voip-number"
                            >
                                <span>{{ item.voip | formatEmpty }}</span>
                                <span class="tag">{{ item.platform }}</span>
                                <span>{{ $t('密码') }}</span>
                                <span
                                    v-if="!item.show"
                                    class="password-hide-item"
                                >******</span>
                                <span
                                    v-else
                                    class="password-show-item"
                                >{{ item.token }}</span>
                                <v-icon
                                    v-tip:dynamicData="!item.show ? $t('显示密码') : $t('隐藏密码')"
                                    :name="item.show ? 'password-hide' : 'password-show'"
                                    @click="handleToggleHide(item)"
                                    class="pointer"
                                />
                            </div>
                        </div>
                    </v-description-item>
                </v-descriptions>
                <v-page-header level="section" :title="$t('登录管理')">
                    <v-button
                        slot="extra"
                        v-if="smsAbility"
                        type="link"
                        kind="primary"
                        @click="handleChangePassword(2)"
                        class="change-password"
                    >
                        <v-icon name="basic_lock_line" remote />
                        {{ $t('修改密码') }}
                    </v-button>
                </v-page-header>
                <v-descriptions>
                    <v-description-item
                        v-if="smsAbility"
                        :text="$t('手机')"
                    >
                        <div style="display: inline-block;">
                            <template v-if="userinfo.login_mobile">
                                <span class="mr-10">{{ userinfo.login_mobile | encryptTel(vm) }}</span>
                                <span class="bind-phone-tag"> <v-tag
                                    color="gray"
                                    :text="$t('已绑定')"
                                    shape="capsule"
                                /></span>
                                <v-button
                                    @click="handleChangeMobile"
                                    inline
                                    type="link"
                                    kind="primary"
                                >
                                    {{ $t('更换') }}
                                </v-button>
                            </template>
                            <template v-else>
                                <v-button
                                    @click="handleBindLoginPhone"
                                    inline
                                    type="link"
                                    kind="primary"
                                >
                                    {{ $t('立即绑定') }}
                                </v-button>
                            </template>
                            <p class="description">
                                {{ $t('绑定后改手机号可用于登录、找回密码、拨打企点电话等功能') }}
                            </p>
                        </div>
                    </v-description-item>

                    <v-description-item
                        v-if="isInWhiteList"
                        :text="$t('账号名@域名')"
                    >
                        <div>
                            <span class="mr-10  pre-style">{{ (userinfo ? userinfo.account : '-') || '-' }}</span>
                            <template v-if="!userinfo.is_account_active">
                                <v-button
                                    @click="handleChangePassword(1)"
                                    inline
                                    type="link"
                                    kind="primary"
                                >
                                    {{ $t('立即激活') }}
                                </v-button>
                                <p class="description">
                                    {{ $t('激活后可使用账号名@企业域名登录企点') }}
                                </p>
                            </template>
                        </div>
                    </v-description-item>
                    <template v-if="!isPrivate && isInWhiteList">
                        <v-description-item
                            v-if="userinfo.has_call === 0 && userinfo.qq"
                            :text="$t('QQ员工号')"
                        >
                            <div style="display: inline-block;">
                                <span
                                    v-if="userinfo.qq"
                                    class="mr-10"
                                >{{ userinfo.qq | formatEmpty }} </span>
                                <v-button
                                    v-if="userinfo.qq && !userinfo.is_qq_active"
                                    @click="handleActivateQQ"
                                    inline
                                    type="link"
                                    kind="primary"
                                >
                                    {{ $t('立即激活') }}
                                </v-button>
                                <p
                                    v-if="!userinfo.is_qq_active"
                                    class="description"
                                >
                                    {{ $t('激活后可使用QQ员工号登录企点') }}
                                </p>
                            </div>
                        </v-description-item>
                        <!-- <description-item label="微信">
                            <div style="display: inline-block;">
                                <span
                                    v-if="userinfo.weixin"
                                    class="mr-10"
                                >{{ userinfo.weixin }}</span>
                                <text-button
                                    v-if="!userinfo.weixin"
                                    @click="handleBindWechat"
                                    inline
                                >
                                    绑定
                                </text-button>
                                <text-button
                                    v-if="userinfo.weixin"
                                    @click="handleChangeWechat"
                                    inline
                                >
                                    更换
                                </text-button>
                                <p
                                    v-if="!userinfo.weixin"
                                    class="description"
                                >
                                    绑定后可使用微信扫码登录
                                </p>
                            </div>
                        </description-item> -->
                    </template>
                </v-descriptions>
            </div>
            <!-- 修改密码 -->
            <change-password-dialog
                v-if="changePasswordDialogVisiable"
                :show.sync="changePasswordDialogVisiable"
                :mobile="userinfo.login_mobile"
                :username="changePWDAccount"
                :mode="changeMode"
                :aid="userinfo.aid"
                @on-success="handleFresh"
            />
            <!-- 激活qq -->
            <activate-qq-dialog
                v-if="activateQQDialogVisiable"
                :show.sync="activateQQDialogVisiable"
                :aid="userinfo.str_aid"
                @on-success="handleFresh"
            />
            <!-- 绑定微信弹窗 -->
            <bind-wechat-dialog
                :name.sync="showDialogName"
                :aid="userinfo.aid"
                @on-success="handleFresh"
            />
            <!-- 替换微信弹窗 -->
            <replace-wechat-dialog
                :name.sync="showDialogName"
                :aid="userinfo.aid"
                @on-success="handleFresh"
                @on-return-validate="handleReturnValidate"
            />
            <!-- 绑定手机 -->
            <bind-tel-dialog
                v-if="userinfo && bindTelDialogVisiable"
                :aid="userinfo.aid"
                :mobile="defaultInputMobile"
                :account="userinfo.account"
                :is-private="isPrivate"
                :show-sync-bind="showSyncBind"
                :from="bindTelFrom"
                :is-change-tel="isChangeTel"
                :is-check-sync="isCheckSync"
                :is-mobile-link="userinfo.is_mobile_link"
                :show.sync="bindTelDialogVisiable"
                :is-in-white-list="isInWhiteList"
                @on-bind-success="fetchPersonInfo"
                :has-check-phone="hasCheckPhone"
            />
            <!-- 替换手机 -->
            <replace-mobile-dialog
                :name.sync="showDialogName"
                @on-success="handleFresh"
                @on-return-validate="handleReturnValidate"
            />
            <!-- 验证弹窗 -->
            <validate-account-dialog
                :name.sync="showDialogName"
                :aid="userinfo.aid"
                :login-mobile="userinfo.login_mobile"
                :validate-type="validateType"
                :current-validate-type.sync="currentValidateType"
                :bind-type="bindType"
                :wechat-name="userinfo.weixin"
                @on-jump-validate="handleJumpValidate"
                @on-validate-success="handleValidateAccountSuccess"
            />
            <!-- 修改头像 -->
            <change-avatar-dialog
                ref="avatar"
                @changeAvatar="url => userinfo.avatar_url = url"
                :defaultAvatar="defaultAvatar"
            />
        </template>
    </div>
</template>
<script>
import { Icon } from 'vhtml-ui';
import { isInAccountMark } from 'src/cgi/getWhiteList';
import { isPrivate, smsAbility } from 'src/config/private';
import { encryptTel } from '@/components/international-tel-input/utils';
import Gateway from 'src/utils/Gateway';
import BindTelDialog from '../components/dialog/bind-tel-dialog';
import ChangePasswordDialog from '../components/dialog/change-password-dialog';
import ActivateQqDialog from '../components/dialog/activate-qq-dialog';
import BindWechatDialog from '../components/dialog/bind-wechat-dialog';
import ReplaceMobileDialog from '../components/dialog/replace-mobile-dialog';
import ReplaceWechatDialog from '../components/dialog/replace-wechat-dialog';
import ValidateAccountDialog from '../components/dialog/validate-account-dialog.vue';
import ChangeAvatarDialog from '../components/dialog/change-avatar-dialog';

const req = require.context('../assets/icons', false, /[^.]+\.svg$/);
Icon.addSprites(req);
const SELF_URL = '/v1/basic.account.account_web.Account/GetProfileV2'; // 个人资料
const DEFAULT_AVATAR = '//bqq.gtimg.com/qidian/src/themes/blue/common/images/default_avatar.png';
export default {
    components: {
        // DescriptionItem,
        // BlockDescription,
        // TextButton,
        // BlockItemTitle,
        BindTelDialog,
        ChangePasswordDialog,
        ActivateQqDialog,
        BindWechatDialog,
        ReplaceWechatDialog,
        ValidateAccountDialog,
        ReplaceMobileDialog,
        ChangeAvatarDialog,
    },
    filters: {
        formatEmpty(value) {
            return value || '-';
        },
        encryptTel(val, vm) {
            return vm.userinfo.is_uid_login ? val : encryptTel(val);
        },
    },
    data() {
        return {
            isInWhiteList: false,
            bindTelDialogVisiable: false,
            changePasswordDialogVisiable: false,
            bindWechatDialogVisiable: false,
            activateQQDialogVisiable: false,
            // activateDomainLoginDialogVisiable: false,
            changeAccountDialogVisiable: false,
            accountValidateDialogVisiable: false,
            internationalTel: '',
            userinfo: null,
            pageLoading: false,
            defaultAvatar: DEFAULT_AVATAR,
            isPrivate, // 是否是私有化
            smsAbility, // 是否有发短信功能
            bindTelFrom: '', // person-info | login-manage
            showSyncBind: false,
            validateType: '', // wecaht | mobile | all
            currentValidateType: '', // wecaht | mobile
            defaultInputMobile: '',
            bindType: '',
            isChangeWechat: false,
            isCheckSync: false,
            showDialogName: '',
            cache: {
                returnDialogName: '',
            },
            vm: this,
            isChangeTel: false,
            changeMode: false, // 修改密码框如果true则是激活账号模式反之就是普通的修改密码
            hasCheckPhone: false,
        };
    },
    computed: {
        isUidLogin() {
            return this.userinfo && this.userinfo.is_uid_login;
        },
        changePWDAccount() {
            return `${this.userinfo.name}(${this.userinfo.user_str_id})`;
        },
    },
    watch: {
        internationalTel(newValue) {
            console.log('newvalue', newValue);
        },
    },
    created() {
        this.fetchPersonInfo();
        isInAccountMark().then((val) => {
            this.isInWhiteList = val;
        });
    },
    methods: {
        handleChangeAvatar() {
            this.$refs.avatar.imgSrc = this.userinfo.avatar_url;
            this.$refs.avatar.visiableDialog = true;
        },
        handleFresh() {
            // 头部修改密码时，如果没绑定手机，提示绑定手机，在个人资料绑定手机后，应该刷新一下，才正常
            // 单纯的重新请求详情接口，头部修改密码还是会提示绑定手机
            window.location.reload();
        },
        handleReturnValidate() {
            this.showDialogName = this.cache.returnDialogName;
        },
        handleJumpValidate({ changeType, data }) {
            if (changeType === 'wechat') {
                this.showDialogName = 'replaceWechatDialog';
                this.cache = {
                    returnDialogName: data.returnDialogName,
                };
            } else {
                this.showDialogName = '';
                this.bindTelDialogVisiable = true;
                this.cache = {
                    returnDialogName: data.returnDialogName,
                };
            }
        },
        handleValidateAccountSuccess({ changeType }) {
            if (changeType === 'wechat') {
                this.showDialogName = 'bindWechatDialog';
            } else {
                this.showDialogName = '';
                this.hasCheckPhone = true;
                this.bindTelDialogVisiable = true;
                this.showSyncBind = true;
                // this.showSyncBind = this.userinfo.is_uid_login;
                this.bindTelFrom = 'login-manage';
            }
        },
        handleBindWechat() {
            if (this.isUidLogin) {
                // uid登录，不需要验证，直接换绑
                this.showDialogName = 'bindWechatDialog';
            } else if (this.userinfo.login_mobile) {
                // 如果绑定了手机和微信，则需要验证，可以通过手机或扫码任意一种方式验证
                this.showDialogName = 'validateAccountDialog';
                this.validateType = 'mobile';
                this.bindType = 'wechat';
                this.currentValidateType = 'mobile';
            } else {
                // 没有手机的情况
                this.showDialogName = 'bindWechatDialog';
            }
        },
        handleChangeWechat() {
            // 更换微信
            if (this.isUidLogin) {
                // uid登录，不需要验证，直接换绑
                this.showDialogName = 'bindWechatDialog';
            } else if (this.userinfo.login_mobile) {
                // 如果绑定了手机和微信，则需要验证，可以通过手机或扫码任意一种方式验证
                this.showDialogName = 'validateAccountDialog';
                this.validateType = 'all';
                this.bindType = 'wechat';
                this.currentValidateType = 'wechat';
            } else {
                // 没有手机的情况
                this.showDialogName = 'validateAccountDialog';
                this.validateType = 'wechat';
                this.bindType = 'wechat';
                this.currentValidateType = 'wechat';
            }
        },
        handleChangeBindPhone() {
            this.isChangeTel = true;
            this.handleBindPhone();
        },
        handleBindPhone() {
            this.showSyncBind = true;
            // this.showSyncBind = this.userinfo.is_uid_login;
            this.bindTelFrom = 'person-info';
            this.bindTelDialogVisiable = true;
            this.defaultInputMobile = this.userinfo.mobile;
        },
        handleChangeMobile() {
            this.hasCheckPhone = false;
            if (this.isUidLogin) {
                this.isChangeTel = true;
                this.bindTelDialogVisiable = true;
                this.showSyncBind = true;
                // this.showSyncBind = this.userinfo.is_uid_login;
                this.bindTelFrom = 'login-manage';
                // this.isCheckSync = true;
                this.defaultInputMobile = this.userinfo.login_mobile;
            } else if (this.userinfo.weixin) {
                // 如果已经绑定了手机号，需要进行手机号校验
                this.isChangeTel = true;
                this.showDialogName = 'validateAccountDialog';
                this.validateType = 'all';
                this.bindType = 'mobile';
                this.defaultInputMobile = this.userinfo.login_mobile;
                this.currentValidateType = 'mobile';
            } else {
                this.isChangeTel = true;
                this.bindTelDialogVisiable = true;
                this.showSyncBind = true;
                // this.showSyncBind = this.userinfo.is_uid_login;
                this.bindTelFrom = 'login-manage';
                this.defaultInputMobile = this.userinfo.login_mobile;
            }
            // if (this.userinfo.login_mobile && this.userinfo.weixin) {
            //     this.accountValidateDialogVisiable = true;
            //     this.validateType = 'all';
            //     this.currentValidateType = type;
            //     this.bindType = type;
            //     return;
            // }
            // if (this.userinfo.login_mobile) {
            //     this.accountValidateDialogVisiable = true;
            //     this.validateType = 'mobile';
            //     this.bindType = type;
            //     return;
            // }
            // if (this.userinfo.weixin) {
            //     this.bindWechatDialogVisiable = true;
            //     this.isChangeWechat = true;
            //     this.validateType = 'wechat';
            //     this.bindType = type;
            //     return;
            // }
        },
        handleBindLoginPhone() {
            if (this.isUidLogin) {
                this.bindTelDialogVisiable = true;
                this.showSyncBind = true;
                // this.showSyncBind = this.userinfo.is_uid_login;
                this.bindTelFrom = 'login-manage';
                this.isCheckSync = true;
                this.defaultInputMobile = this.userinfo.login_mobile;
            } else if (this.userinfo.weixin) {
                // 如果已经绑定了手机号，需要进行手机号校验
                this.validateType = 'wechat';
                this.bindType = 'mobile';
                this.currentValidateType = 'wechat';
                this.showDialogName = 'validateAccountDialog';
            } else {
                this.bindTelDialogVisiable = true;
                this.showSyncBind = true;
                // this.showSyncBind = this.userinfo.is_uid_login;
                this.bindTelFrom = 'login-manage';
                this.defaultInputMobile = this.userinfo.login_mobile;
            }
        },
        handleChangePassword(flag) {
            if (this.userinfo.login_mobile) {
                this.changePasswordDialogVisiable = true;
                this.changeMode = flag === 1;
            } else {
                this.$message.error(this.$t('请先在个人资料中绑定手机号'));
            }
        },
        // handleActivateAccount() {
        //     if (this.userinfo.mobile) {
        //         this.activateDomainLoginDialogVisiable = true;
        //     } else {
        //         this.$message.error('请先在个人资料中绑定手机号');
        //     }
        // },
        handleActivateQQ() {
            this.activateQQDialogVisiable = true;
        },
        // 个人资料
        fetchPersonInfo() {
            this.pageLoading = true;
            Gateway.get(SELF_URL)
                .then((res) => {
                    this.pageLoading = false;
                    this.userinfo = res.data || {};
                    console.log(this.userinfo);
                    // 延迟拉头像
                    this.$nextTick(() => {
                        this.$refs.avatar.fetchHistoryAvatar();
                    });
                })
                .catch((error) => {
                    this.pageLoading = false;
                    console.warn(error);
                });
        },
        handleToggleHide(item) {
            this.$set(item, 'show', !item.show);
        },
    },
};
</script>
<style lang="less">
.customer-person-info {
    width: 900px;
    background: #ffffff;
    border: 1px solid #ebedf2;
    border-radius: 4px;
    margin: 19px auto;
    padding: 40px;
    .info-head {
        display: flex;
        align-items: center;
        .avatar {
            width: 64px;
            height: 64px;
            border-radius: 50%;
        }
        .username {
            font-size: 26px;
            color: #1e2330;
            margin-left: 20px;
        }
    }
    .personal-avatar {
        position: relative;
        border-radius: 50%;
        .personal-avatar-mask {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            text-align: center;
            line-height: 64px;
            background: rgba(0, 0, 0, 0.4);
            font-size: 13px;
            color: #fff;
            cursor: pointer;
            display: none;
            border-radius: 50%;
        }
        &:hover {
            .personal-avatar-mask {
                display: block;
            }
        }
    }
    .description {
        font-size: 12px;
        color: rgb(168, 171, 179);
    }
    .pointer {
        cursor: pointer;
    }
    .space-between {
        justify-content: space-between;
    }
    .flex-row {
        display: flex;
        align-items: center;
        &.voip-number {
            &:not(:last-child) {
                margin-bottom: 15px;
            }
        }
    }
    .tag {
        background: #e4e8ea;
        border-radius: 12px;
        display: inline-block;
        padding: 0 10px;
        height: 22px;
        text-align: center;
        margin: 0 10px;
    }
    .password-hide-item {
        margin: 0 12px;
        font-size: 16px;
        transform: translateY(5px);
    }
    .password-show-item {
        margin: 0 12px;
    }

    .mr-10 {
        margin-right: 10px;
    }
    .change-password {
        display: flex;
        align-items: center;
    }
}
.clearfix::after {
    content: '';
    display: block;
    clear: both;
    height: 0;
}
.pre-style {
    white-space: pre;
}
.bind-phone-tag {
    margin-right: 10px;
    vertical-align: middle;
    .v-tag {
        vertical-align: top;
    }
}
</style>
